import { useEffect, useState } from 'react';
import { useSearchStore } from '../../stores/search-store.js';
import { useDeckStore } from '../../stores/deck-store.js';
import { useLandProposalStore } from '../../stores/land-proposal-store.js';
import { useSearch } from '../../hooks/useSearch.js';
import { SearchBar } from './SearchBar.js';
import { SortControl } from './SortControl.js';
import { FilterBar } from './FilterBar.js';
import { AdvancedSearchPanel } from './AdvancedSearchPanel.js';
import { ActiveFiltersChips } from './ActiveFiltersChips.js';
import { SearchResultsArea } from './SearchResultsArea.js';
import { Pagination } from './Pagination.js';
import LandAutofillModal from '../land-autofill/LandAutofillModal.js';
import { LandProposalView } from '../land-autofill/LandProposalView.js';

export function SearchZone() {
  const activeTagSlugs = useSearchStore((s) => s.activeTagSlugs);
  const activeRecBucket = useSearchStore((s) => s.activeRecBucket);
  const { execute } = useSearch();

  // Deck state for the land base button
  const entries = useDeckStore((s) => s.entries);
  const colorIdentity = useDeckStore((s) => s.colorIdentity);

  // Modal visibility state — SearchZone owns this per architecture
  const [showLandModal, setShowLandModal] = useState(false);

  // Land proposal store — when a proposal is pending, show LandProposalView instead of search results
  const pendingProposal = useLandProposalStore((s) => s.pendingProposal);

  const hasEntries = entries.length > 0;
  const isColorless = colorIdentity.length === 0;

  // Auto-execute when tag filters change from TagProfile
  const tagKey = JSON.stringify(activeTagSlugs);
  useEffect(() => {
    if (activeTagSlugs.length > 0) {
      void execute(1);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tagKey]);

  // Auto-execute when a Discover-tab bucket chip is toggled. Mirrors the
  // activeTagSlugs effect — chip click writes a rectag clause to the bar,
  // which we then re-run as a search.
  useEffect(() => {
    if (activeRecBucket !== null) {
      void execute(1);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeRecBucket]);

  return (
    <div className="flex flex-col flex-1 min-w-0 h-full bg-gray-950">
      {/* Search header — shrinks and scrolls only when needed */}
      <div className="px-4 pt-4 pb-3 border-b border-gray-800 space-y-3 min-h-0 overflow-y-auto">
        <SearchBar />
        <div className="flex items-center justify-between">
          <SortControl />
        </div>
        <FilterBar
          onGenerateLandBase={() => setShowLandModal(true)}
          showLandButton={hasEntries}
          isColorless={isColorless}
          isLandModalOpen={showLandModal}
        />
        <AdvancedSearchPanel />
        <ActiveFiltersChips />
      </div>

      {/* Results — show proposal view when a land proposal is pending */}
      {pendingProposal ? (
        <LandProposalView />
      ) : (
        <>
          <SearchResultsArea />
          <Pagination />
        </>
      )}

      {/* Land autofill modal */}
      {showLandModal && (
        <LandAutofillModal onClose={() => setShowLandModal(false)} />
      )}
    </div>
  );
}
